<template>
  <div class="AbsencePersonel">
    <box class="" :title="this.$t('search')">
      <section-date-time-search-panel :accessTo="18" @search="search" />
      <div class="px-3">
        <v-row>
          <v-col
            cols="6"
            sm="auto"
            class="px-1"
            v-for="(item, index) in checkboxList"
            :key="index"
          >
            <v-checkbox
              :value="index.toString()"
              :label="item"
              multiple
              v-model="selectedCheckboxes"
              @change="checkboxChange"
            ></v-checkbox>
          </v-col>
        </v-row>
      </div>
    </box>
    <box class="mt-2" :title="$t('personelList')">
      <template slot="top-action-view">
        <v-icon
          v-if="list.length > 0 && visiblePrint"
          @click="print"
          color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div class="vacationList">
        <div v-if="list.length > 0">
          <absence-personel-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClick"
          />
          <absence-personel-list-mob
            @onClick="onClick"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <empty-list />
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import AbsencePersonelListMob from "../../components/personelOperationReport/absencePersonelList/AbsencePersonelListMob.vue";
import AbsencePersonelListWeb from "../../components/personelOperationReport/absencePersonelList/AbsencePersonelListWeb.vue";
import SectionDateTimeSearchPanel from "../../components/personelOperationReport/SectionDateTimeSearchPanel.vue";
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
export default {
  components: {
    SectionDateTimeSearchPanel,
    AbsencePersonelListWeb,
    AbsencePersonelListMob,
  },
  data() {
    return {
      totalList: [],
      list: [],
      checkboxList: [
        "غیبت",
        "مرخصی روزانه",
        "ماموریت روزانه",
        "مرخصی ساعتی",
        "ماموریت ساعتی",
        "تاخیر سرویس",
      ],
      selectedCheckboxes: ["0"],
      visiblePrint: false,
      sectionCode: "",
      date: "",
      time: "",
    };
  },
  methods: {
    search(params) {
      this.sectionCode = params.sectionCode;
      this.date = params.date;
      this.time = params.time;
      this.$store.dispatch("GetAbsentPersons", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          //var list = result.data.Table;
          this.totalList = result.data.Table;
          this.checkboxChange();
          this.checkVisiblePrint();
        }
      });
    },
    checkboxChange() {
      this.list = [];
      this.totalList.forEach((element) => {
        if (this.selectedCheckboxes.includes(element.AbsentType)) {
          this.list.push(element);
        }
      });
    },
    onClick() {},
    checkVisiblePrint() {
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var adminPermissionList =
          this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            return false;
          }
          return true;
        });
      }
    },
    print() {
      let routeData = this.$router.resolve({
        name: "rpAbsence",
        query: {
          SC: this.sectionCode,
          BD: this.date,
          BT: this.time.replace(":", "_"),
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style>
</style>